/* DON'T EDIT THIS FILE: edit original and run build again */ // only add exports if a custom handler is needed.
// Given firebase is a frontend dep, we hardcode these values.
// This might bring problems if firebase decides to change their error handling interface.
export const authErrorWrongPassword = "auth/wrong-password";
export const authErrorUserNotFound = "auth/user-not-found";
export const authErrorInvalidEmail = "auth/invalid-email";
export const authErrorEmailExists = "auth/email-already-exists";
export const authErrorWeakPassword = "auth/weak-password";
